<template>
    <modal
            :ref="name"
            :name="name"
            :draggable="minimized ? false : draggable"
            :width="minimized ? minimizedWidth : width"
            :height="height"
            :reset="reset"
            :clickToClose="clickToClose"
            :overlayTransition="overlayTransition"
            :transition="transition"
            :shiftX="modalShift.x"
            :shiftY="modalShift.y"
    >
        <div :class="{minimizable: true, minimized: minimized}">
            <slot/>
        </div>
    </modal>
</template>

<script>
    let minimizedModals = [];

    export default {
        name: "MinimizableModal",

        data() {
            return {
                modalShift: {
                    x: this.shiftX,
                    y: this.shiftY
                },
                minimizedWidth: 300
            }
        },

        props: {
            minimized: {
                required: true
            },
            visible: {
                required: true
            },
            name: {},
            draggable: {},
            width: {},
            height: {},
            reset: {},
            clickToClose: {},
            shiftX: {},
            shiftY: {},
            overlayTransition: {},
            transition: {},
        },

        watch: {
            minimized: {
                handler() {
                    this.changeMinimizeState();
                }
            },

            visible: {
                handler() {
                    if (this.visible) {
                        this.$modal.show(this.name);
                    } else {
                        this.$modal.hide(this.name);
                    }
                }
            }
        },

        methods: {
            async changeMinimizeState() {
                let self = this;

                let index = minimizedModals.indexOf(this);

                if (this.minimized && index === -1) {
                    minimizedModals.push(this);
                    index = minimizedModals.length - 1;
                } else if (!this.minimized) {
                    minimizedModals.splice(index, 1);

                    for (let i = index; i < minimizedModals.length; i++) {
                        minimizedModals[i].relocate();
                    }
                }

                const modal = this.$refs[this.name];

                if (this.minimized) {
                    const windowWidth = modal.viewportWidth - modal.trueModalWidth;
                    const windowHeight = Math.max(modal.viewportHeight - modal.trueModalHeight, 0);

                    const currentLeftShift = modal.shiftLeft + (modal.shiftX * windowWidth);
                    const currentTopShift = modal.shiftTop + modal.shiftY * windowHeight;

                    this.savedModalPosition = {
                        x: currentLeftShift / windowWidth,
                        y: currentTopShift / windowHeight
                    };
                }

                this.$modal.hide(this.name);

                const distance = this.minimizedWidth * 1.05;
                const offset = (distance / (modal.viewportWidth - distance)) * index;

                this.modalShift.x = this.minimized ? (0.85 - offset) : this.savedModalPosition.x;
                this.modalShift.y = this.minimized ? 1 : this.savedModalPosition.y;

                if (this.visible) {
                    await sleep(50);
                    this.$modal.show(this.name);
                }
            },

            async relocate() {
                let index = minimizedModals.indexOf(this);
                const modal = this.$refs[this.name];

                this.$modal.hide(this.name);

                const distance = this.minimizedWidth * 1.05;
                const offset = (distance / (modal.viewportWidth - distance)) * index;

                this.modalShift.x = 0.85 - offset;
                this.modalShift.y = 1;

                if (this.visible) {
                    await sleep(50);
                    this.$modal.show(this.name);
                }
            }
        }
    }
</script>

<style>
    div.minimizable > header.v-toolbar, div.minimizable > header.v-toolbar > div.v-toolbar__content {
        height: 48px !important;
    }

    div.minimized > header.v-toolbar, div.minimized > header.v-toolbar > div.v-toolbar__content {
        height: 32px !important;
    }
</style>
